import { useEffect, useRef, useState } from "react";
import { createEventPdf } from "./GenerateWorkflowPdf";
import { url } from "./core/route/Route";
import { Icon } from "./core/ui/icons";

export function EventDetailsPdf(props: {
	eventID: string, 
}) {

	const pdfUrl = useRef("");

	useEffect(() => {
		function onUnload() {
			if (pdfUrl.current) {
				URL.revokeObjectURL(pdfUrl.current);
				pdfUrl.current = "";
			}
		}

		window.addEventListener("unload", onUnload);

		return function() {
			window.removeEventListener("unload", onUnload);
			onUnload();
		};
	}, []);	

	const [title, setTitle] = useState("");
	

	createEventPdf(props.eventID).then((pdf) => {
		const pdfBlob = new Blob([pdf.bytes], { type: 'application/pdf', });

		pdfUrl.current = URL.createObjectURL(pdfBlob);

		let title = pdf.src.title;
		const fn = url.get("fn");
		if (fn) {
			title = decodeURIComponent(fn);
		}

		setTitle(title);

		// // Assuming pdfDoc is your dynamically generated PDF content (e.g., ArrayBuffer or Uint8Array)
		// // Convert the PDF content to a blob
		// const pdfBlob = new Blob([pdf.bytes], { type: 'application/pdf' });

		// // Create a URL for the blob
		// const pdfUrl = URL.createObjectURL(pdfBlob);

		// // Create an iframe element to display the PDF
		// const iframe = document.createElement('iframe');

		// iframe.addEventListener("load", () => {
		// 	/// ****************************************************
		// 	// IMPORTANT - also need to factor in clean up here
		// 	// should be using URL.revokeObjectURL() to free mem
		// 	URL.revokeObjectURL(pdfUrl);
		// });
				
		// iframe.src = pdfUrl;
		// iframe.style.width = '100vw';
		// iframe.style.height = '100vh';
		// document.body.appendChild(iframe);


	});

	return (
		<>
			{
				pdfUrl.current &&
				<div className="flex vert bg-black">
					<div
						className="text-inverse flex horiz align-center gap-5"
						style={{
							height:"50px"
						}}
					>
						<Icon type="logo-shield" size="large" style={{width:"32px", height:"32px"}} />
						<b className="font-med">{title}</b>
						<a
							className="button primary"
							href={pdfUrl.current}
							download={title}
						>Download</a>							
					</div>

					<embed src={pdfUrl.current} 
						style={{
							width: "100vw",
							height: "calc(100vh - 50px)",
						}} 
					/>
					
				</div>
			}
		</>
	);

}

